import React from 'react';
import { Box } from '@mui/material';
import { TableDetailsData } from '../../../../../components';
import DataDetailsTable from '../../../../../components/details-table/DataDetailsTable';
import { generalDetailStyles } from './details-components-helpers';

export const LinkDetails = ({ data }: TableDetailsData): React.JSX.Element => {
    return (
        <Box sx={generalDetailStyles.generalDetailsContainer}>
            <DataDetailsTable data={data} />
        </Box>
    );
};
